import React from 'react'

import Checkbox from 'common/Checkbox'
import FormUnControlled from 'common/Forms/Base/FormUnControlled'

export default props => <FormUnControlled tag={Checkbox} {...props} />
